"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Set body overflow.
 */
function setBodyOverflow(enabled) {
  var body = document.body;

  if (!body) {
    return;
  }

  body.style.overflow = enabled ? '' : 'hidden';
}
/**
 * Prevent default event.
 */


function preventDefaultTouchmove(event) {
  event.preventDefault();
}
/**
 * Add prevent default touchmove event listener.
 */


function disableBodyTouchmove() {
  var body = document.body;

  if (!body) {
    return;
  }

  body.addEventListener('touchmove', preventDefaultTouchmove);
}
/**
 * Remove prevent default touchmove event listener.
 */


function enableBodyTouchmove() {
  var body = document.body;

  if (!body) {
    return;
  }

  body.removeEventListener('touchmove', preventDefaultTouchmove);
}
/**
 * `BodyScroll` component.
 */


var BodyScroll = /*#__PURE__*/function (_Component) {
  _inherits(BodyScroll, _Component);

  var _super = _createSuper(BodyScroll);

  function BodyScroll() {
    _classCallCheck(this, BodyScroll);

    return _super.apply(this, arguments);
  }

  _createClass(BodyScroll, [{
    key: "setBodyScroll",
    value:
    /**
     * Set body scroll.
     */
    function setBodyScroll(enabled) {
      setBodyOverflow(enabled);

      if (enabled) {
        enableBodyTouchmove();
      } else {
        disableBodyTouchmove();
      }
    }
    /**
     * Component did mount.
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.enabled) {
        this.setBodyScroll(false);
      }
    }
    /**
     * Component did update.
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps) {
      var enabled = this.props.enabled;

      if (enabled === previousProps.enabled) {
        return;
      }

      this.setBodyScroll(enabled);
    }
    /**
     * Component will unmount.
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setBodyScroll(true);
    }
    /**
     * Render.
     */

  }, {
    key: "render",
    value: function render() {
      return this.props.children || null;
    }
  }]);

  return BodyScroll;
}(_react.Component);
/**
 * Export `BodyScroll` component.
 */


var _default = BodyScroll;
exports["default"] = _default;